export const formatHourFromUTC = (utcDate) => {
  if (!utcDate) {
    return "Fecha no proporcionada";
  }

  const date = new Date(utcDate);
  const locale = "es-ES"; // You can change this to the desired locale
  const options = { timeZone: "Europe/Madrid" }; // Ensure the time is interpreted as Europe/Madrid

  return date.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    ...options,
  });
};
